import {API} from "../../../api/api";
import {SystemServerVersionsAPIRoutes} from "./apiRoutes";

const getSystemServerVersions = () => {
    return API.request({
        routeID: SystemServerVersionsAPIRoutes.GET_SYSTEM_SERVER_VERSIONS,
        odataParameters: {}
    });
};

const toggleSystemServerVersionStatus = (systemServerVersionId) => {
    return API.request({
        routeID: SystemServerVersionsAPIRoutes.TOGGLE_SYSTEM_SERVER_VERSION_STATUS,
        routeParameters: {version_id: systemServerVersionId},
        formData: false
    });
}

export const SystemServerVersionsAPI = {
    getSystemServerVersions,
    toggleSystemServerVersionStatus
};